module.exports = __webpack_public_path__ + "img/Rick_vanVliet_rond.9570f290.png";